import React from "react";
import { useIntl } from "react-intl";

import { TextField } from "@material-ui/core";

import { common } from "../../../messages";
import { useBmapi } from "../../../utils/bmapi-context";

export function Name({ value, onChange }) {
  const intl = useIntl();
  const { bmapi } = useBmapi();

  return (
    <TextField
      fullWidth
      label={intl.formatMessage(common.name)}
      margin="normal"
      name="name"
      onChange={onChange}
      required={bmapi.settings.profileRequired.includes("name")}
      value={value}
    />
  );
}
